export class CacheConfiguration
{
    public ConfigurationTypeID: number;
    public Active: boolean;
    public Value: string;
    public Message: string;
    public SettingType: number;

    constructor(
        ConfigurationTypeID: number,
        Active: boolean,
        Value: string,
        Message: string,
        SettingType: number,
    )
    {
        this.ConfigurationTypeID = ConfigurationTypeID,
        this.Active = Active,
        this.Value = Value;
        this.Message = Message,
        this.SettingType = SettingType
    }
}